<template>
  <section class="progress-circle" data-tracking-id="specification-temperature">
    <p class="btn-title">
      {{ title }}
      <a v-if="lightBoxCopy.title" class="info-button_popin" @click="togglePopin">
        <svg class="icon-info_small">
          <use xlink:href="#icon-Info_small" />
        </svg>
      </a>
    </p>
    <ul>
      <li data-tracking-label="less">
        <a class="progress-circle__buttons" @click="updateQty(false)">
          <ul>
            <li />
          </ul>
        </a>
      </li>
      <li>
        <div class="progress-circle-svg__container">
          <div class="progress-circle-svg__background">
            <img
              class="progress-circle-svg__background--conic"
              :src="gradient.png"
              style="border-radius: 50%"
            />
          </div>

          <div class="progress-circle-svg__percent">
            <span>
              {{temperature}}
              <b>°{{UnitOfMesure}}</b>
            </span>
          </div>

          <svg
            class="progress-circle-svg"
            viewBox="0 0 106 106"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            :class="{'progress-circle-svg--negative': getOrientation}"
          >
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="ProgressBar" transform="translate(-17.000000, -17.000000)">
                <circle
                  id="Oval"
                  stroke="#00ff0000"
                  stroke-width="0"
                  fill-rule="nonzero"
                  cx="70"
                  cy="70"
                  r="50"
                />
                <path
                  class="progress-circle-svg__path"
                  d="M70,120 C97.6142375,120 120,97.6142375 120,70 C120,42.3857625 97.6142375,20 70,20 C42.3857625,20 20,42.3857625 20,70 C20,97.6142375 42.3857625,120 70,120 Z"
                  id="Oval-Copy"
                  stroke="#fff"
                  stroke-width="11"
                  :stroke-dasharray="circle"
                  fill-rule="nonzero"
                  transform="translate(70.000000, 70.000000) rotate(-125.000000) translate(-70.000000, -70.000000) "
                />
                <path
                  class="progress-circle-svg__path--line"
                  d="M70,120 C97.6142375,120 120,97.6142375 120,70 C120,42.3857625 97.6142375,20 70,20 C42.3857625,20 20,42.3857625 20,70 C20,97.6142375 42.3857625,120 70,120 Z"
                  id="Oval-Copy"
                  stroke="#EAEAEA"
                  stroke-width="2"
                  :stroke-dasharray="circle"
                  fill-rule="nonzero"
                  transform="translate(70.000000, 70.000000) rotate(-125.000000) translate(-70.000000, -70.000000) "
                />
              </g>
            </g>
          </svg>
        </div>
      </li>
      <li data-tracking-label="more">
        <a class="progress-circle__buttons" @click="updateQty(true)">
          <ul>
            <li />
            <li />
          </ul>
        </a>
      </li>
    </ul>
    <lightbox :visible="lightboxVisible" v-on:close="lightboxVisible = false">
      <div class="lightbox-simple-content">
        <ul>
          <li>
            <span v-html="lightBoxCopy.title" />
            <p v-html="lightBoxCopy.subtitle" />
          </li>
        </ul>
      </div>
    </lightbox>
  </section>
</template>

<script>
import { mapState } from "vuex";
import Lightbox from "@/components/shared/LightBox";
export default {
  props: {
    title: String,
    step: Number,
    lightBoxBtn: Boolean,
    lightBoxCopy: Object,
    active: { Type: Number, required: true, default: 0 }
  },
  data() {
    return {
      percent: 100,
      orientation: true,
      temperature: 10,
      gradient: new window.ConicGradient({
        stops:
          "#F4E9D5,#F4E9D5, #EEE1CE, #E3D3C0, #D4C0AE, #C8AF9E, #BFA494, #B59887,  #AB8A7B, #A17E6F, #987263, #8D6355, #805346, #805346",
        size: 129
      }),
      patch: false,
      lightboxVisible: false
    };
  },
  computed: {
    circle() {
      return (this.percent / 100) * 100 * Math.PI + ",9999";
    },
    getOrientation() {
      // if temperature is below 0 so reverse the chart
      // the patch allow the glitch on the progress bar from -5 to 0, don't
      return this.temperature >= 0 && !this.patch ? false : true;
    },
    ...mapState({
      txt: state => state.txt,
      passengers: state => state.range.passengers,
      celsius: state => state.txt.common.celsius
    }),
    UnitOfMesure: function() {
      // `this` points to the vm instance
      return this.celsius ? "C" : "F";
    }
  },
  mounted() {
    this.temperature = Number(this.active);

    // set default progress from parent
    return this.temperature > 0
      ? (this.percent = 100 - this.convertTempToPurcent(this.active))
      : (this.percent = 100 + this.convertTempToPurcent(this.active));
  },
  watch: {
    // whenever question changes, this function will run
    temperature: function(newValue, oldValue) {
      // emit to parent
      this.$emit("event_temperature", newValue);

      // fix the issue from -5 to 0 on the progress bar
      return newValue === 0 && oldValue === -5
        ? (this.patch = true)
        : (this.patch = false);
    }
  },
  components: {
    Lightbox
  },
  methods: {
    updateQty(bool) {
      // update the temperature
      this.updateTemperature(bool, 5);
      // the progress bar goes two way (yes, this is so damn silly)
      // so you need if its below 0, we need to reverse the calcul
      if (this.temperature > 0) {
        return this.udpateToPositive(bool, 8.33);
      }
      if (this.temperature < 0) {
        return this.udpateNegative(bool, 8.33);
      }
      // there are some bug when its 0, so I separed from the rest
      return this.reInitProgress();
    },
    udpateToPositive(bool, qty) {
      if (bool && this.percent <= 45) return;
      if (bool) {
        return this.updateProgress(false, qty);
      }
      return this.updateProgress(true, qty);
    },
    udpateNegative(bool, qty) {
      if (!bool && this.percent <= 70) return;
      if (bool) {
        return this.updateProgress(true, qty);
      }
      return this.updateProgress(false, qty);
    },
    reInitProgress() {
      // Because our progress bar is silly, 100 is 0 actually.
      // For some technical reason you might guess, we need to reveal a gradiant background instead of just increase the size of a svg
      return (this.percent = 100);
    },
    updateTemperature(bool, qty) {
      // do nothing ig the temperature is below or after the range
      if (
        (!bool && this.temperature <= -20) ||
        (bool && this.temperature >= 35)
      )
        return;

      // either add or remove 1 unit
      return bool
        ? (this.temperature = this.temperature + Number(qty))
        : (this.temperature = this.temperature - Number(qty));
    },
    updateProgress(bool, qty) {
      // console.log(bool, qty);
      return bool
        ? (this.percent = this.percent + Number(qty))
        : (this.percent = this.percent - Number(qty));
    },

    //================ START POPIN ================//

    togglePopin() {
      this.lightboxVisible = !this.lightboxVisible;
    },

    //================ END POPIN ================//

    //================ START CONVERT TEMP TO PURCENT ================//

    convertTempToPurcent(temp) {
      // get temperature and divide it by steps (5)
      return (temp / this.step) * 8.33;
    }

    //================ END CONVERT TEMP TO PURCENT ================//
  }
};
</script>